export default {
  contractItems: [],
  contractItem: undefined,
};
